import {
  Component,
  OnInit,
  ViewChild,
  Renderer,
  ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { VolvoApiService } from "../../services/volvo-api.service";
import { CookieService } from "ngx-cookie-service";
import { Observable, throwError } from "rxjs";
import { PageConfiguration } from "../../models/page-configuration";
import { CalloutsComponent } from "../../components/callouts/callouts.component";
import { Title } from '@angular/platform-browser';

@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.scss"],
})
export class LandingComponent implements OnInit {
  @ViewChild("pagecontent") pageContent: ElementRef;
  public pageConfig$: Observable<PageConfiguration>;
  localStrings$: Observable<Array<any>>;
  hasShareForm: boolean;
  hasFindDealerForm: boolean;
  promotionAlias: string;
  isHotelPromotion: boolean = false;

  AdditionalFieldsFormID: number;
  Guid: string;
  CountryID: number;

  @ViewChild(CalloutsComponent)
  private calloutsComp: CalloutsComponent;

  constructor(
    private route: ActivatedRoute,
    private volvoApi: VolvoApiService,
    private cookieService: CookieService,
    private router: Router,
    private renderer: Renderer,
    private titleService: Title
    // private metaService: Meta
  ) {}

  ngOnInit() {

    this.promotionAlias = this.route.snapshot.paramMap.get("promotionAlias");

    this.route.queryParams.subscribe((params) => {
      // get query string code in the popup
      const idMeCode_Pram = params["code"];
      const idMeErr_Pram = params["error"];
      const idMeErrDetails_Pram = params["error_description"];

      if (idMeErr_Pram) {
        // delete the cookies so that the user
        // must reauthenicate w/ idme
        this.cookieService.delete("idMeInfo");
        this.cookieService.delete("idMeCode");

        throwError(`${idMeErr_Pram} : ${idMeErrDetails_Pram}`);

        this.closeIdMePopup();
      } else if (idMeCode_Pram) {
        const idMeCode = this.cookieService.get("idMeCode");

        // save idme code in the cookie
        // if we have not already done so
        if (idMeCode !== idMeCode_Pram) {
          const fiveMinutes = 0.0035;
          this.cookieService.set(
            "idMeCode",
            idMeCode_Pram,
            fiveMinutes,
            null,
            null,
            true,
            "Lax"
          );
        }

        this.closeIdMePopup();
      }
    });

    this.pageConfig$ = this.volvoApi.getPageConfiguration(this.promotionAlias);

    this.pageConfig$.subscribe((r) => {
      // redirect to main site when page doesn't exist
      if (!r.ID) {
        this.router.navigateByUrl("notfound");
      } else {
        this.AdditionalFieldsFormID = r.AdditionalFieldsFormID;
        this.Guid = r.Guid;
        this.CountryID = r.CountryID;

        const _pagetitle = r.PageTitle ? r.PageTitle : "Volvo Affinity Programs";
        this.titleService.setTitle(_pagetitle);
        
        // // Meta Tags - Primary
        // this.metaService.addTag({ name: 'title', content: _pagetitle });
        // this.metaService.addTag({ name: 'description', content: r.PageDescription });

        // // Meta Tags - Open Graph / Facebook
        // this.metaService.addTag({ property: 'og:type', content: 'website' });
        // this.metaService.addTag({ property: 'og:url', content: window.location.href });
        // this.metaService.addTag({ property: 'og:title', content: _pagetitle });
        // this.metaService.addTag({ property: 'og:description', content: r.PageDescription });
        // this.metaService.addTag({ property: 'og:image', content: r.PageMetaImg });
        
        // // Meta Tags - Twitter
        // this.metaService.addTag({ property: 'twitter:card', content: 'summary_large_image' });
        // this.metaService.addTag({ property: 'twitter:url', content: window.location.href });
        // this.metaService.addTag({ property: 'twitter:title', content: _pagetitle });
        // this.metaService.addTag({ property: 'twitter:description', content: r.PageDescription });
        // this.metaService.addTag({ property: 'twitter:image', content: r.PageMetaImg });


        if (r.ShareCallout) {
          this.hasShareForm = true;
        }
        r.Callout.forEach((c) => {
          if (c.ModalName === "find-participating-dealer") {
            this.hasFindDealerForm = true;
          }
        });
      }
    });

    this.localStrings$ = this.volvoApi.getPromotionLocalizationString();
  }

  openModal(modalName: string) {
    this.calloutsComp.openModal(modalName);
  }

  skipToContent() {
    this.renderer.invokeElementMethod(this.pageContent.nativeElement, "focus");
  }

  closeIdMePopup() {
    // if the page has been opened in
    // the idme popup, after authentication
    if (window.opener) {
      // try to close reload the parent,
      // and close the window
      try {
        window.opener.location.reload();
        window.close();
      } catch (error) {
        console.error(error);
        throwError(`${error}`);
      }
    }
  }
}
